import { createAction } from '@reduxjs/toolkit'
import { NewNotificationMessage } from 'interfaces'

export const addNotification =
  createAction<NewNotificationMessage>('addNotification')

export const removeNotification = createAction<{ id: string }>(
  'removeNotification',
)
